var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"display-1 text-center"},[_vm._v("Game of Life")]),_c('RulesPopover'),_c('GameOfLifeGrid',{staticClass:"game-of-life",attrs:{"grid":_vm.grid}}),_c('Controls',{on:{"iterate-invoked":function($event){return _vm.iterate()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }